import HttpRequest from '@/config/axios'
import config from '@/config/index'

const axios = new HttpRequest(config.baseUrl)
export default axios


// WEBPACK FOOTER //
// ./src/config/api.request.js